import { message } from 'antd';
import {
  ICurrentUser,
  IError,
  IResult,
  IUserProfile,
  IApiKeyDetails,
} from '../../types/api';
import Api, { axiosInstance } from '../Api';

export default class CurrentUser {
  endPoint = 'CurrentUser';

  async getCurrentUser() {
    try {
      const r = await axiosInstance.get<IResult<ICurrentUser>>(
        `/${this.endPoint}`
      );
      if (r.data.Error) {
        return undefined;
      }
      return r.data.Result;
    } catch {
      return undefined;
    }
  }

  async getApiKey() {
    try {
      const r = await axiosInstance.get<IResult<IApiKeyDetails>>(
        `/${this.endPoint}/getApiKey`
      );
      if (r.data.Error || r.status != 200) {
        return undefined;
      }
      return r.data.Result;
    } catch {
      return undefined;
    }
  }

  async registerDownloaderAPIKey() {
    return axiosInstance
      .post<IResult<string>>(`/${this.endPoint}/RegisterDownloaderAPIKey`)
      .then((d) => d.data)
      .catch((error) => {
        if (error.ErrorMessage) {
          message.error(error.ErrorMessage);
        }
      });
  }

  async getUserProfile() {
    return axiosInstance
      .get<IResult<IUserProfile>>(`/${this.endPoint}/GetUserProfile`)
      .then((d) => {
        return d.data;
      })
      .catch((error) => {
        if (error.ErrorMessage) {
          message.error(error.ErrorMessage);
        }
      });
  }
}
